import { render, staticRenderFns } from "./GroupDictionaryItem.vue?vue&type=template&id=a9ef63ca&scoped=true&"
import script from "./GroupDictionaryItem.vue?vue&type=script&lang=js&"
export * from "./GroupDictionaryItem.vue?vue&type=script&lang=js&"
import style0 from "./GroupDictionaryItem.vue?vue&type=style&index=0&id=a9ef63ca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9ef63ca",
  null
  
)

export default component.exports